// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  matchId: __t.string().primaryKey().name("match_id"),
  hostPlayerId: __t.string().name("host_player_id"),
  hostIdentity: __t.identity().name("host_identity"),
  claimedAt: __t.timestamp().name("claimed_at"),
});
